import { Page } from '@/core/architecture'

import { ConsoleItemInformationLimitUserTemplate } from './template'
import { useViewModel } from './viewModel'

export const ConsoleItemInformationLimitUser: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleItemInformationLimitUserTemplate state={state} {...actions} />
}
